import 'jquery-ajax-unobtrusive';
import '../../../scss/sites/website/website-style.scss';
import Bookingmask from '@png/npm-bookingmask';
import Header from '@png/npm-header';
import Iibe from '@png/npm-iibe';
import SelectDropdown from '@png/npm-select-dropdown';
import SvgIcon from '@png/npm-svg-icon';
import AddressLookup from '../../modules/geolocate';
import Sticky from '../../modules/sticky';
import ImageLinker from '../../modules/imagelinker';
import LightGallery from '../../modules/light-gallery';
import Recaptcha from '../../modules/recaptcha';
import Webinar from '../../modules/webinar';

document.addEventListener('DOMContentLoaded', () => {
  new Webinar().init();
  // Svg icons
  new SvgIcon().init();

  // Recaptcha
  new Recaptcha().init();

  // Header
  new Header({
    desktopMenuBreakpoint: 992,
    openUrlOnToggle: false
  }).init();

  // Address lookup
  new AddressLookup().init();

  // Bookingmask
  new Bookingmask({
    displayFormat: 'd/m/Y',
    dateFormat: 'd-m-Y',
    datepickerType: 'separate',
    disableMobile: false
  }).init();

  // Select dropdown
  new SelectDropdown().init();

  // Sticky
  new Sticky({
    velocity: 50
  }).init();

  // IIBE
  new Iibe().init();

  // Image linker
  new ImageLinker().init();

  // Light Gallery
  new LightGallery().init();
});
